import { InjectionToken } from '@angular/core';
import { LoginConfig } from '../shared/models/index';

export const loginConfig = new InjectionToken<LoginConfig>('loginConfig');
